import { render } from "./Tasks.vue?vue&type=template&id=6b9cdfb8"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__